import {
  getTicketCustomer,
  getTicketTemplate,
  getFeedbackTemplate,
  getCustomerSearch,
  getEscalatedCustomerTickets,
  getEscalatedOfficeTickets,
  getTicketSubCategory,
} from "@/http/tickets";

export default {
  namespaced: true,
  state: {
    CustomerList: {},
    ticketTemplateInfo: {},
    feedbackTemplateInfo: [],
    ticketListData: [],
    ticketSubCategory: [],
  },
  actions: {
    async fetchTicketCustemor({ commit }) {
      try {
        const resp = await getTicketCustomer();
        commit("SET_TICKET_CUSTOMER", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async fetchTicketTemplate({ commit }) {
      try {
        const resp = await getTicketTemplate();
        commit("SET_TICKET_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async fetchFeedbackTemplate({ commit }) {
      try {
        const resp = await getFeedbackTemplate();
        commit("SET_FEEDBACK_TEMPLATE", resp.data);
        return resp;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async fetchCustomerSearch({ commit }, data) {
      try {
        const resp = await getCustomerSearch(
          data.type,
          data.statusType,
          data.fromDate,
          data.toDate
        );
        commit("SET_CUSTOMER_SEARCH", resp.data.pageItems);
        return resp;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async getEscalatedCustomerTickets({ commit }, id) {
      try {
        return await getEscalatedCustomerTickets(id);
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async getEscalatedOfficeTickets({ commit }, id) {
      try {
        return await getEscalatedOfficeTickets(id);
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
    async getTicketSubCategory({ commit }, id) {
      try {
        let res = await getTicketSubCategory(id);
        commit("SET_TICKET_SUBCATEGORY", res.data.subCategory);
        return res;
      } catch (error) {
        throw Error("Something went wrong");
      }
    },
  },
  mutations: {
    SET_TICKET_CUSTOMER(state, payload) {
      state.CustomerList = payload;
    },
    SET_TICKET_TEMPLATE(state, payload) {
      state.ticketTemplateInfo = payload;
    },
    SET_FEEDBACK_TEMPLATE(state, payload) {
      state.feedbackTemplateInfo = payload;
    },
    SET_CUSTOMER_SEARCH(state, payload) {
      state.ticketListData = payload;
    },
    SET_TICKET_SUBCATEGORY(state, payload) {
      state.ticketSubCategory = payload;
    },
  },
  getters: {},
};
